import { Link } from "react-router-dom";
import { Phone, FileText, CalendarCheck } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { CTA, PHONE_TEL, PHONE_DISPLAY } from "@/seo/seoConfig";

const CtaButtons = ({ dark = false, testPrefix = "cta" }) => {
  const { language } = useLanguage();
  const c = CTA[language];
  const outline = dark
    ? "border-2 border-white text-white hover:bg-white hover:text-[#0F172A]"
    : "border-2 border-[#0F172A] text-[#0F172A] hover:bg-[#0F172A] hover:text-white";
  return (
    <div className="flex flex-col sm:flex-row flex-wrap gap-3" data-testid={`${testPrefix}-buttons`}>
      <a href={`tel:${PHONE_TEL}`} className="inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-white px-6 py-3.5 text-xs md:text-sm uppercase tracking-widest font-semibold hover:bg-[#B5952F] transition-colors duration-300" data-testid={`${testPrefix}-call`}>
        <Phone className="w-4 h-4" /> {c.call} {PHONE_DISPLAY}
      </a>
      <Link to="/#estimado" className={`inline-flex items-center justify-center gap-2 px-6 py-3.5 text-xs md:text-sm uppercase tracking-widest font-semibold transition-colors duration-300 ${dark ? "bg-white text-[#0F172A] hover:bg-slate-100" : "bg-[#0F172A] text-white hover:bg-[#1E293B]"}`} data-testid={`${testPrefix}-estimate`}>
        <FileText className="w-4 h-4" /> {c.estimate}
      </Link>
      <Link to="/#citas" className={`inline-flex items-center justify-center gap-2 px-6 py-3 text-xs md:text-sm uppercase tracking-widest font-semibold transition-colors duration-300 ${outline}`} data-testid={`${testPrefix}-schedule`}>
        <CalendarCheck className="w-4 h-4" /> {c.schedule}
      </Link>
    </div>
  );
};

export default CtaButtons;
